// @flow

export { getFeatureByName, getSafeFeatureByName } from './get-feature-by-name';
export { IfFeature } from './if-feature';
export { hasFeature } from './has-feature';
export type { Feature, FeatureName } from './types';
export { getSupportedTraits } from './get-traits';
